export const ROLE_KEY_EDITOR = 1;
export const ROLE_KEY_ADMIN = 2;
export const ROLE_KEY_IT_ADMIN = 3;
export const ROLE_KEY_ANALYTICS_ADMIN = 4;

export const RECRUITER_ROLE_LABELS = {
  [ROLE_KEY_EDITOR]: 'Editor',
  [ROLE_KEY_ANALYTICS_ADMIN]: 'Analytics Admin',
  [ROLE_KEY_ADMIN]: 'Admin',
  [ROLE_KEY_IT_ADMIN]: 'IT Admin',
};
